import { KompisPriceFormatter } from '@inter-ikea-kompis/react-components';
import { useServiceSettings } from 'contexts/serviceSettings';
import React from 'react';
import { TypographyProps } from 'styled-system';

export type Props = TypographyProps & {
  amount: number;
  animated?: boolean;
  className?: string;
};

const Price = ({ amount = 0, animated, className }: Props) => {
  const { dexfSettings } = useServiceSettings();
  return (
    <KompisPriceFormatter
      data-testid="price"
      settings={dexfSettings}
      animated={animated}
      amount={amount}
      className={className}
    />
  );
};

export default Price;
